<template>
  <div>
    <!--  Banner Starts Here   -->
    <section class="inner_banner">
      <div class="container_large">
        <div class="inner_banner_content">
          <h1>Frequently Asked <span>Questions</span></h1>
        </div>
      </div>
    </section>
    <!--  Banner Ends Here   -->

    <!--   Main Content Start Here   -->
    <main>
      <section class="default_wraper">
        <div class="container_large">
          <div class="row">
            <vue-google-autocomplete
              ref="address"
              id="map"
              classname="form-control"
              placeholder="Please type your address"
              v-on:placechanged="getAddressData"
              country="us"
            >
            </vue-google-autocomplete>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
import VueGoogleAutocomplete from "vue-google-autocomplete";

export default {
  components: { VueGoogleAutocomplete },
  data() {
    return {
      address: null,
      given_areas: [],

    };
  },
  methods: {
    getAddressData: function (addressData, placeResultData, id) {
      console.log(addressData.postal_code);
      console.log(placeResultData);

      if(addressData && addressData.postal_code){
          const index = this.given_areas.findIndex(it => it == addressData.postal_code);
            if (index === -1) {
                console.log('postal code not exist in array')
                
            } else {
                console.log('postal code exist in array')
            }
      }
      // console.log(id);

      this.address = addressData;
    },
  },
  created() {
    this.given_areas.push("02127");
    this.given_areas.push("02118");
    this.given_areas.push("02123");
    this.given_areas.push("02116");
    this.given_areas.push("02108");
    this.given_areas.push("02215");
    this.given_areas.push("02120");
    this.given_areas.push("02474");
    this.given_areas.push("02476");
    this.given_areas.push("02134");
    this.given_areas.push("02478");
    this.given_areas.push("02135");
    this.given_areas.push("02445");
    this.given_areas.push("02446");
    this.given_areas.push("02138");
    this.given_areas.push("02138");
    this.given_areas.push("02139");
    this.given_areas.push("02140");
    this.given_areas.push("02141");
    this.given_areas.push("02142");
    this.given_areas.push("02163");
    this.given_areas.push("02238");
    this.given_areas.push("02150");
    this.given_areas.push("02108");
    this.given_areas.push("02109");
    this.given_areas.push("02110");
    this.given_areas.push("02111");
    this.given_areas.push("02112");
    this.given_areas.push("02117");
    this.given_areas.push("02118");
    this.given_areas.push("02127");
    this.given_areas.push("02113");
    this.given_areas.push("02114");
    this.given_areas.push("02115");
    this.given_areas.push("02116");
    this.given_areas.push("02123");
    this.given_areas.push("02128");
    this.given_areas.push("02133");
    this.given_areas.push("02163");
    this.given_areas.push("02196");
    this.given_areas.push("02199");
    this.given_areas.push("02205");
    this.given_areas.push("02206");
    this.given_areas.push("02212");
    this.given_areas.push("02215");
    this.given_areas.push("02266");
    this.given_areas.push("02283");
    this.given_areas.push("02201");
    this.given_areas.push("02203");
    this.given_areas.push("02204");
    this.given_areas.push("02210");
    this.given_areas.push("02211");
    this.given_areas.push("02217");
    this.given_areas.push("02222");
    this.given_areas.push("02241");
    this.given_areas.push("02284");
    this.given_areas.push("02293");
    this.given_areas.push("02295");
    this.given_areas.push("02297");
    this.given_areas.push("02298");
    this.given_areas.push("02129");
    this.given_areas.push("02467");
    this.given_areas.push("02121");
    this.given_areas.push("02122");
    this.given_areas.push("02124");
    this.given_areas.push("02125");
    this.given_areas.push("02149");
    this.given_areas.push("02130");
    this.given_areas.push("02148");
    this.given_areas.push("02153");
    this.given_areas.push("02155");
    this.given_areas.push("02176");
    this.given_areas.push("02492");
    this.given_areas.push("02461");
    this.given_areas.push("02464");
    this.given_areas.push("02459");
    this.given_areas.push("02465");
    this.given_areas.push("02458");
    this.given_areas.push("02462");
    this.given_areas.push("02151");
    this.given_areas.push("02118");
    this.given_areas.push("02119");
    this.given_areas.push("02120");
    this.given_areas.push("02170");
    this.given_areas.push("02169");
    this.given_areas.push("02171");
    this.given_areas.push("02269");
    this.given_areas.push("02144");
    this.given_areas.push("02145");
    this.given_areas.push("02451");
    this.given_areas.push("02452");
    this.given_areas.push("02453");
    this.given_areas.push("02454");
    this.given_areas.push("02472");
    this.given_areas.push("02471");
    this.given_areas.push("02477");
    this.given_areas.push("02482");
    this.given_areas.push("02132");
    this.given_areas.push("01890");

    console.log(this.given_areas)
  },
};
</script>


// WEBPACK FOOTER //
// src/components/testPlaces.vue